import { render, staticRenderFns } from "./label-detail.vue?vue&type=template&id=73908569&"
import script from "./label-detail.vue?vue&type=script&lang=js&"
export * from "./label-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports